import React, { memo } from 'react';
import * as Styled from './styled';
import TablePageSizer from '../table-page-sizer/TablePageSizer';
import {
  Paginator,
  SelectOption,
} from '@leasequery/lq.react-component-library';
import { noop } from '../../../util';
import { StringOrComponent } from '../../../models';

interface TableFooterProps {
  itemCount: number;
  pageSize: number;
  pageIndex: number;
  displayedRange?: number;
  globalFilter?: string;
  singlePageView: boolean;
  labels?: {
    itemCount?: StringOrComponent;
    perPage?: string;
    showing?: string;
  };
  onPageSizeChange?: (item: SelectOption<number>) => void;
  onPageinatorClick?: (pageIndex: number) => void;
}

function TableFooter({
  itemCount,
  pageSize,
  pageIndex,
  displayedRange,
  labels,
  onPageSizeChange,
  onPageinatorClick,
  singlePageView,
}: TableFooterProps): JSX.Element {
  return !singlePageView && (
    <Styled.TableFooter>
      <>
        <TablePageSizer
          itemCount={itemCount}
          pageSize={pageSize}
          pageIndex={pageIndex}
          labels={labels}
          onChange={onPageSizeChange}
        />
        {itemCount > 0 && (
          <Paginator
            pageSize={pageSize}
            pageIndex={pageIndex}
            displayedRange={displayedRange}
            itemCount={itemCount}
            onClick={onPageinatorClick}
          />
        )}
      </>
    </Styled.TableFooter>
  );
}

TableFooter.defaultProps = {
  displayedRange: 10,
  onPageSizeChange: noop,
  onPageinatorClick: noop,
};

export default memo(TableFooter);
